// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2duhB","list":"BalanceDue_list__3PMDw","listRow":"BalanceDue_listRow__3t0zG","total":"BalanceDue_total__3NdiT"};